module.exports = __webpack_public_path__ + "media/img/illustrations/icons/applications-dropdown-note-f0c8dbdf6dc99c0696e638b381e432e9.svg";